import { signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';

export class BaseStore<T> {
  private readonly _data = signal<T | undefined>(undefined, { equal: () => false });

  readonly data$: Observable<T | undefined> = toObservable(this._data);

  get snapshot(): T | undefined {
    return this._data();
  }

  update(data: T): void {
    this._data.set(data);
  }
}
